import { useState } from "react";

interface BankDetails {
  email: string;
  bank: string;
  routing: string;
  account: string;
  swift: string;
  dueDate: string;
}

interface UseBankStateReturn {
  bankName: string;
  bank: string;
  numberNotmatchedError: boolean;
  wireDetails: BankDetails;
  setBankName: (name: string) => void;
  setBank: (name: string) => void;
  setnumberNotmatchedError: (err: boolean) => void;
  setWireDetails: (details: BankDetails) => void;
  resetBankState: () => void;
}

const defaultWireDetails: BankDetails = {
  email: "",
  bank: "",
  routing: "",
  account: "",
  swift: "",
  dueDate: "",
};

export const useBankState = (): UseBankStateReturn => {
  const [bankName, setBankName] = useState<string>("");
  const [bank, setBank] = useState<string>("");
  const [numberNotmatchedError, setnumberNotmatchedError] =
    useState<boolean>(false);
  const [wireDetails, setWireDetails] =
    useState<BankDetails>(defaultWireDetails);

  const resetBankState = () => {
    setBankName("");
    setBank("");
    setnumberNotmatchedError(false);
    setWireDetails(defaultWireDetails);
  };

  return {
    bankName,
    bank,
    numberNotmatchedError,
    wireDetails,
    setBankName,
    setBank,
    setnumberNotmatchedError,
    setWireDetails,
    resetBankState,
  };
};
